<template>
  <div class="content-5">
    <v-progress-linear
      v-if="showProgressbar"
      :value="stockLeft"
      :background-opacity="1"
      height="30"
      reactive
      :color="getProgressColor(stockLeft)"
      @click="
        $emit(
          'click:calendarEntry',
          product,
          capacity,
          event,
          startDate,
          endDate
        )
      "
    >
      <template #default>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <span
              style="width: 100%"
              class="text-center white--text font-weight-thin"
              v-on="on"
            >
              <v-row class="justify-space-between align-center">
                <!-- event title if any -->
                <v-col
                  v-if="hasDescription"
                  class="pl-1 py-0 pr-0 text-left"
                  :class="{
                    'col-8': hasAllElements,
                    'col-12 pr-1': hasDescription && !hasCapacity, // description only
                  }"
                >
                  <span>{{ description | maxLength(descriptionLength) }}</span>
                </v-col>

                <!-- stock left -->
                <v-col
                  v-if="hasCapacity"
                  class="py-0 pl-0 pr-1"
                  :class="{
                    'col-4': hasAllElements,
                    'col-12 text-right': !hasDescription, // capacity only
                  }"
                >
                  <span class="text-no-wrap">
                    {{ capacity.getCount() }} / {{ capacity.getCapacity() }}
                  </span>
                </v-col>
              </v-row>
            </span>
          </template>
          <!-- tooltip text -->
          <!-- attribute text -->
          <span v-if="capacity && capacity.hasAttributeValue()">
            {{ $t(capacity.getTranslation()) }}
          </span>

          <!-- product title -->
          <span v-else>
            {{ $t(product.getTranslation()) }}
          </span>
        </v-tooltip>
      </template>
    </v-progress-linear>
  </div>
</template>

<script>
import Product from '../../classes-shared/products/Product'

export default {
  name: 'CapacityProgressBar',

  props: {
    product: {
      type: Product,
      required: true,
      default: null,
    },

    // Type: ValueCapacity
    capacity: {
      required: true,
      default: null,
      type: Object,
    },
    event: {
      required: false,
      default: null,
      type: Object,
    },

    // type: YYYY-MM-DD
    startDate: {
      type: String,
      required: true,
    },

    // type: YYYY-MM-DD
    endDate: {
      type: String,
      required: true,
    },

    // overwrite description by custom text
    customProgressDescription: {
      type: String,
      required: false,
      default: '',
    },
    hideDescription: {
      type: Boolean,
      required: false,
      default: false,
    },
    // grey background color
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    // show capacity progress bar at all?
    showProgressbar() {
      // consider validity dates
      const validityDates = this.product.getAvailableDates('dateString')
      let validityDatesOk = true
      if (validityDates.length)
        validityDatesOk = validityDates.includes(this.endDate)

      return (
        ((this.capacity && !this.capacity.isHidden()) ||
          this.capacity === null) &&
        validityDatesOk
      )
    },

    // shortcuts
    description() {
      if (this.event) return this.event.title
      else if (this.customProgressDescription)
        return this.customProgressDescription
      else if (
        !this.hideDescription &&
        this.capacity &&
        this.capacity.getTitle()
      )
        return this.capacity.getTitle()
      else if (!this.hideDescription && this.product)
        return this.product.getTitle()
      return null
    },

    stockLeft() {
      if (this.capacity) return this.capacity.getStockLeftInPercentage()
      return 0
    },

    hasDescription() {
      return this.description
    },

    hasCapacity() {
      return this.capacity
    },

    hasAllElements() {
      return this.hasDescription && this.hasCapacity
    },

    descriptionLength() {
      // all elements
      if (this.hasAllElements) return 20
      // description only
      if (this.hasDescription) return 30
      else return 10
    },
  },

  methods: {
    getProgressColor(percent) {
      if (this.disabled) return 'grey'
      // handle event specifications
      if (this.event) {
        // inacitve event?
        if (!this.event.active) return 'grey'
      }

      if (percent <= 33) {
        // name of color
        return 'green'
      } else if (percent > 33 && percent < 100) {
        return 'warning'
      } else if (percent >= 100) {
        return 'error'
      }
      return 'error'
    },
  },
}
</script>
